import React, {Component} from 'react';
import {Select, message} from 'antd';
import HttpTool from '../../../../tool/HttpTool';
import APILXD from '../../../../http/APILXD';

/**
 * 灵能充值金额选择器
 * 金额档位来自充值套餐(productType = power_deposit)，套餐金额单位为分，展示时转换为元
 */
class DepositAmountSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            amountList: [],
            amount: undefined,
        };
    }

    componentDidMount() {
        this.getAmountList();
    }

    getAmountList() {
        this.setState({loading: true});
        HttpTool.post(APILXD.pricePackageGetList, (code, msg, json) => {
            let amountList = [];
            for (let obj of (json || [])) {
                amountList.push(Number((obj.money / 100).toFixed(2)));
            }
            this.setState({
                amountList,
                loading: false,
            });
        }, (code, msg) => {
            this.setState({loading: false});
            message.warning(msg);
        }, {
            productType: 'power_deposit',
            page: 1,
            pageSize: 100,
        });
    }

    render() {
        return (
            <Select
                allowClear={true}
                loading={this.state.loading}
                placeholder={'请选择充值金额'}
                style={{width: '100%'}}
                value={this.state.amount}
                onChange={(value) => {
                    this.setState({
                        amount: value,
                    }, () => {
                        //值发生变化后同步给Layout做参数收集
                        this.props.verification(this.props.data, value === undefined ? null : value);
                    });
                }}
                options={this.state.amountList.map((amount) => {
                    return {
                        label: `¥ ${amount}`,
                        value: amount,
                    };
                })}
            />
        );
    }
}

export default DepositAmountSelect;
